import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f49fa6b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "praise-modal__delivery" }
const _hoisted_2 = {
  key: 0,
  class: "praise-modal__delivery__content"
}
const _hoisted_3 = {
  key: 0,
  class: "tags-send-method-mismatch-message"
}

import { computed, type ComputedRef } from 'vue'
import Select from 'primevue/select'
import PraiseModalDeliveryEmail from '@/components/FrontlineManagerDash/PraiseModal/PraiseModalDeliveryEmail.vue'
import PraiseModalDeliveryMethod from '@/components/FrontlineManagerDash/PraiseModal/PraiseModalDeliveryMethod.vue'
import {
    SEND_METHOD_EMAIL,
    SEND_METHOD_INTERNAL_NOTE,
    SendMethod,
} from '@/entities/frontlineManagerDash'
import { faEnvelope, faMessageLines } from 'fontawesome/pro-regular-svg-icons'
import { getSendMethodLabel } from '@/utils/frontlineManagerDash'

interface Props {
    installedApps: SendMethod[]
    praiseeEmail: string | undefined
    hasInvalidEmail?: boolean
    errorMsg?: string
    hasMentionsOrTags: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'StepDeliver',
  props: /*#__PURE__*/_mergeModels({
    installedApps: {},
    praiseeEmail: {},
    hasInvalidEmail: { type: Boolean },
    errorMsg: {},
    hasMentionsOrTags: { type: Boolean }
  }, {
    "emails": {
    type: String,
    default: '',
},
    "emailsModifiers": {},
    "selectedSendMethod": {
    type: String,
    default: SEND_METHOD_INTERNAL_NOTE,
},
    "selectedSendMethodModifiers": {},
    "selectedSendMethodData": {
    type: {},
    default: {},
},
    "selectedSendMethodDataModifiers": {},
  }),
  emits: /*#__PURE__*/_mergeModels(['sendMethodChanged'], ["update:emails", "update:selectedSendMethod", "update:selectedSendMethodData"]),
  setup(__props: any, { emit: __emit }) {

const props = __props

const emails = _useModel(__props, 'emails')
const selectedSendMethod = _useModel(__props, 'selectedSendMethod')
const selectedSendMethodData = _useModel(__props, 'selectedSendMethodData')

const emit = __emit

const sendMethods: ComputedRef<SendMethod[]> = computed(() => {
    let availableMethods: SendMethod[] = [
        {
            key: SEND_METHOD_INTERNAL_NOTE,
            label: 'Internal Note',
            faIcon: faMessageLines,
        },
        ...props.installedApps,
        {
            key: SEND_METHOD_EMAIL,
            label: 'Email',
            faIcon: faEnvelope,
            extraFieldType: 'text',
            toolTipMsg:
                "Additional recipients will be CC'd. Emails must be separated with ',' or ';'",
        },
    ]
    return availableMethods
})

const onSendMethodChanged = (value, label: string) => {
    emit('sendMethodChanged', value, label)
}

const showExtraMethodField = (method: SendMethod, fieldType: string) => {
    return (
        method.key === selectedSendMethod.value &&
        method.extraFieldType === fieldType
    )
}

const showTagsToSendMethodMismatchMessage = computed(() => {
    return (
        props.hasMentionsOrTags &&
        selectedSendMethod.value !== SEND_METHOD_INTERNAL_NOTE
    )
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sendMethods.value, (method) => {
      return (_openBlock(), _createBlock(PraiseModalDeliveryMethod, {
        key: method.key,
        "selected-send-method": selectedSendMethod.value,
        "onUpdate:selectedSendMethod": _cache[2] || (_cache[2] = ($event: any) => ((selectedSendMethod).value = $event)),
        method: method,
        onChange: onSendMethodChanged
      }, {
        default: _withCtx(() => [
          (showExtraMethodField(method, 'text'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(PraiseModalDeliveryEmail, {
                  emails: emails.value,
                  "onUpdate:emails": _cache[0] || (_cache[0] = ($event: any) => ((emails).value = $event)),
                  "praisee-email": _ctx.praiseeEmail,
                  "is-invalid": _ctx.hasInvalidEmail,
                  "error-msg": _ctx.errorMsg
                }, null, 8, ["emails", "praisee-email", "is-invalid", "error-msg"])
              ]))
            : _createCommentVNode("", true),
          (
                    showExtraMethodField(method, 'channel-dropdown') &&
                    method.data.channelList.length
                )
            ? (_openBlock(), _createBlock(_unref(Select), {
                key: 1,
                modelValue: selectedSendMethodData.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedSendMethodData).value = $event)),
                options: method.data.channelList,
                "option-label": "name",
                placeholder: "Select Channel",
                class: "praise-modal__select-input"
              }, null, 8, ["modelValue", "options"]))
            : _createCommentVNode("", true)
        ], undefined, true),
        _: 2
      }, 1032, ["selected-send-method", "method"]))
    }), 128)),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (showTagsToSendMethodMismatchMessage.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Tags and hashtags will not be applied in " + _toDisplayString(_unref(getSendMethodLabel)(selectedSendMethod.value)), 1))
          : _createCommentVNode("", true)
      ], undefined, true),
      _: 1
    })
  ]))
}
}

})